import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('onlyLatinWithNumbersAndSpecial', /^[A-Za-z0-9 \-,./]*$/);
